import styled from "styled-components"

export const AnchorToGoTo = styled.div`
  position: absolute;
  top: -6rem;
  opacity: 0;
`
